import get from 'lodash/get';

export const getDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

export const addEvent = (event) => {
  const dataLayer = getDataLayer();
  dataLayer.push(event);
};

export const pageviewTrack = (data = {}, location = null) => {
  const currentLocation = location || window.location;
  const userId = get(data, 'user.id');
  const isFree = get(data, 'profile.subscription.is_free');
  const emailConfirmationNeeded = get(data, 'profile.email_confirmation_needed');

  const event = {
    event: 'pageviewCustomEvent',
    pagePath: `${currentLocation.pathname}${currentLocation.search}${currentLocation.hash}`,
    pageTitle: window.document.title,
    userId: userId || undefined,
    dimension1: userId ? '1' : undefined,
    dimension2: emailConfirmationNeeded === true
      ? true
      : emailConfirmationNeeded === false
        ? false
        : undefined,
    dimension3: isFree === true
      ? false
      : isFree === false
        ? true
        : undefined
  };

  addEvent(event);
};
